
const state = {
  active: true,
  enable_all_events: true,
  enabled_events: {},
  id: null,
  log_email: '',
  owner_id: undefined,
  owner_type: '',
  secret_key: '',
  title: '',
  url: '',
  webhook_version: 'V1',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'url' },
]

export default state
